import styled from 'styled-components';

import SubscribeButtonImport from '../../components/subscribe-button/SubscribeButton';

export const SubscribeButton = styled(SubscribeButtonImport)``;

export const FavoritePodcastContainer = styled.div`
  display: grid;
  margin-top: 3rem;
  grid-gap: 4rem 3rem;
  justify-content: space-between;
  align-items: space-between;
  grid-template-columns: repeat(auto-fill, minmax(170px, 1fr));
  margin-bottom: 5rem;
  height: 100%;
`;

export const PodcastCardContainer = styled.div`
  position: relative;
  @media screen and (hover: hover) {
    ${SubscribeButton} {
      display: none;
    }
    &:hover {
      display: block;
    }
  }
  &:hover {
    @media screen and (hover: hover) {
      ${SubscribeButton} {
        display: block;
      }
    }
  }
`;

export const NoShowsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  max-width: 50rem;
  font-size: 2.4rem;
  font-weight: bold;
  margin: 0 auto;
  color: var(--d-grey);
  img {
    max-width: 200px;
    margin: 3rem 0;
  }
`;
